window.getProductList = (storefrontToken, successCallback, failCallback) => {
    const myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");
    myHeaders.append("X-Shopify-Storefront-Access-Token", storefrontToken);

    let graphql = JSON.stringify({
        query: "{products(first:100) {edges {node {id,title,tags,featuredImage {url},onlineStoreUrl,variants(first: 1) {edges {node {price {amount,currencyCode}}}}}}}}",
        variables: {}
    });
    const requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: graphql,
        redirect: 'follow'
    };

    fetch(config.shopifyApi, requestOptions)
        .then(response => response.json())
        .then(result => {
            successCallback(result);
        })
        .catch(error => failCallback(error));
}

window.getCustomerInfo = (storefrontToken, accessToken, successCallback, failCallback) => {
    const myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");
    myHeaders.append("X-Shopify-Storefront-Access-Token", storefrontToken);

    const graphql = JSON.stringify({
        query: "query {customer(customerAccessToken: \"" + accessToken + "\") {id,firstName,lastName,acceptsMarketing,email,phone,defaultAddress{address1,address2,city,company,country,countryCodeV2},addresses(first:100) {edges{node{address1,address2,city,company,country,countryCodeV2}}}}}",
        variables: {}
    });
    const requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: graphql,
        redirect: 'follow'
    };

    fetch(config.shopifyApi, requestOptions)
        .then(response => response.json())
        .then(result => {
            successCallback(result);
        })
        .catch(error => failCallback(error));
}

window.getCustomerWithOrders = (storefrontToken, accessToken, successCallback, failCallback) => {
    const myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");
    myHeaders.append("X-Shopify-Storefront-Access-Token", storefrontToken);

    const graphql = JSON.stringify({
        query: "query ($customerAccessToken:String!){customer(customerAccessToken: $customerAccessToken) {id,firstName,lastName,acceptsMarketing,email,phone,numberOfOrders,orders(first:250) {edges{node{id,name,orderNumber,processedAt,currencyCode,fulfillmentStatus,financialStatus,currentTotalPrice{amount,currencyCode},currentSubtotalPrice{amount,currencyCode},totalPrice{amount,currencyCode},totalRefunded{amount,currencyCode},subtotalPrice{amount,currencyCode},totalShippingPrice{amount,currencyCode},billingAddress{firstName,lastName,address1,address2,city,province,provinceCode,company,country,countryCodeV2,zip,formattedArea},shippingAddress{firstName,lastName,address1,address2,city,province,provinceCode,company,country,countryCodeV2,zip,formattedArea},lineItems(first:250){edges{node{currentQuantity,quantity,discountAllocations{allocatedAmount{amount,currencyCode}},discountedTotalPrice{amount,currencyCode},originalTotalPrice{amount,currencyCode},variant{title,image{url},product{title}}}}}}}}}}",
        variables: {"customerAccessToken": accessToken}
    });
    const requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: graphql,
        redirect: 'follow'
    };

    fetch(config.shopifyApi, requestOptions)
        .then(response => response.json())
        .then(result => successCallback(result))
        .catch(error => failCallback(error));
}

window.getCheckoutUrl = (storefrontToken, cartId, successCallback, failCallback) => {
    const myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");
    myHeaders.append("X-Shopify-Storefront-Access-Token", storefrontToken);

    const graphql = JSON.stringify({
        query: "query checkoutURL($id: ID!) {cart(id: $id) {checkoutUrl}}",
        variables: {"id": cartId}
    });
    const requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: graphql,
        redirect: 'follow'
    };
    fetch(config.shopifyApi, requestOptions)
        .then(response => response.json())
        .then(result => successCallback(result))
        .catch(error => failCallback(error));
}

window.loadProductInfo = (storefrontToken, id, successCallback, failCallback) => {
    const myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");
    myHeaders.append("X-Shopify-Storefront-Access-Token", storefrontToken);

    const graphql = JSON.stringify({
        query: "query getProductMedia($id: ID!) {product(id: $id) {id,title,tags,totalInventory,availableForSale,description,vendor,featuredImage{ url },media(first: 1) {edges {node {mediaContentType,alt, ...mediaFieldsByType}}},variants(first: 10) {edges {node {id,title,quantityAvailable,price {amount,currencyCode}}}}}},fragment mediaFieldsByType on Media {... on MediaImage {image {url}}}",
        variables: {"id": id}
    });
    const requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: graphql,
        redirect: 'follow'
    };

    fetch(config.shopifyApi, requestOptions)
        .then(response => response.json())
        .then(result => {
            successCallback(result);
        })
        .catch(error => {
            failCallback(error);
        });
}

window.createCart = (storefrontToken, cartInput, successCallback, failCallback) => {
    const myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");
    myHeaders.append("X-Shopify-Storefront-Access-Token", storefrontToken);

    const graphql = JSON.stringify({
        query: "mutation cartCreate($input:CartInput) {cartCreate(input: $input) {cart {id,createdAt,updatedAt,note,checkoutUrl,discountCodes{applicable, code},totalQuantity,lines(first: 100) {edges {node {id,quantity,merchandise {... on ProductVariant {id,title,quantityAvailable,image{url},product{title}}},cost {amountPerQuantity{amount,currencyCode},compareAtAmountPerQuantity{amount,currencyCode},subtotalAmount{amount,currencyCode},totalAmount{amount,currencyCode}},attributes{key,value}}}},attributes{key,value},cost {totalAmount {amount,currencyCode},subtotalAmount {amount,currencyCode},totalTaxAmount {amount,currencyCode}totalDutyAmount {amount,currencyCode}},buyerIdentity {email,phone,customer {id},countryCode,deliveryAddressPreferences {... on MailingAddress {address1,address2,city,provinceCode,countryCodeV2,zip}}}},userErrors {field,message}}}",
        variables: {
            "input": cartInput
        }
    });
    const requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: graphql,
        redirect: 'follow'
    };

    fetch(config.shopifyApi, requestOptions)
        .then(response => response.json())
        .then(result => successCallback(result))
        .catch(error => failCallback(error));
}

window.addOrUpdateCartLine = (storefrontToken, cartId, cartLines, successCallback, failCallback) => {
    const myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");
    myHeaders.append("X-Shopify-Storefront-Access-Token", storefrontToken);

    const graphql = JSON.stringify({
        query: "mutation cartLinesAdd($cartId: ID!, $lines: [CartLineInput!]!) {cartLinesAdd(cartId: $cartId, lines: $lines) {cart {id,createdAt,updatedAt,note,checkoutUrl,discountCodes{applicable, code},totalQuantity,lines(first: 100) {edges {node {id,quantity,merchandise {... on ProductVariant {id,title,quantityAvailable,image{url},product{title}}},cost {amountPerQuantity{amount,currencyCode},compareAtAmountPerQuantity{amount,currencyCode},subtotalAmount{amount,currencyCode},totalAmount{amount,currencyCode}},attributes{key,value}}}},attributes{key,value},cost {totalAmount {amount,currencyCode}subtotalAmount {amount,currencyCode}totalTaxAmount {amount,currencyCode}totalDutyAmount {amount,currencyCode}}buyerIdentity {email,phone,customer {id},countryCode,deliveryAddressPreferences {... on MailingAddress {address1,address2,city,provinceCode,countryCodeV2,zip}}}},userErrors {field,message}}}",
        variables: {
            "cartId": cartId,
            "lines": cartLines
        }
    });
    const requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: graphql,
        redirect: 'follow'
    };

    fetch(config.shopifyApi, requestOptions)
        .then(response => response.json())
        .then(result => successCallback(result))
        .catch(error => failCallback(error));
}

window.getCart = (storefrontToken, cartId, successCallback, failCallback) => {
    const myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");
    myHeaders.append("X-Shopify-Storefront-Access-Token", storefrontToken);

    const graphql = JSON.stringify({
        query: "query ($id:ID!){cart(id: $id) {id,note,checkoutUrl,discountCodes{applicable, code},totalQuantity,createdAt,updatedAt,lines(first: 100) {edges {node {id,quantity,merchandise {... on ProductVariant {id,title,quantityAvailable,image{url},product{title}}},cost {amountPerQuantity{amount,currencyCode},compareAtAmountPerQuantity{amount,currencyCode},subtotalAmount{amount,currencyCode},totalAmount{amount,currencyCode}},attributes{key,value}}}},attributes{key,value},cost {totalAmount {amount,currencyCode} subtotalAmount {amount,currencyCode}, totalTaxAmount {amount,currencyCode},totalDutyAmount {amount,currencyCode}},buyerIdentity {email,phone,customer {id},countryCode,deliveryAddressPreferences {... on MailingAddress {address1,address2,city,provinceCode,countryCodeV2,zip}}}}}",
        variables: {"id": cartId}
    });
    const requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: graphql,
        redirect: 'follow'
    };

    fetch(config.shopifyApi, requestOptions)
        .then(response => response.json())
        .then(result => successCallback(result))
        .catch(error => failCallback(error));
}

window.cartLineUpdate = (storefrontToken, cartId, cartLines, successCallback, failCallback) => {
    const myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");
    myHeaders.append("X-Shopify-Storefront-Access-Token", storefrontToken);

    const graphql = JSON.stringify({
        query: "mutation ($cartId:ID!,$lines:[CartLineUpdateInput!]!){cartLinesUpdate(cartId:$cartId, lines:$lines) {cart {id,note,checkoutUrl,discountCodes{applicable, code},totalQuantity,createdAt,updatedAt,lines(first: 100) {edges {node {id,quantity,merchandise {... on ProductVariant {id,title,quantityAvailable,image{url},product{title}}},cost {amountPerQuantity{amount,currencyCode},compareAtAmountPerQuantity{amount,currencyCode},subtotalAmount{amount,currencyCode},totalAmount{amount,currencyCode}},attributes{key,value}}}},attributes{key,value},cost {totalAmount {amount,currencyCode} subtotalAmount {amount,currencyCode}totalTaxAmount {amount,currencyCode}totalDutyAmount {amount,currencyCode}}buyerIdentity {email,phone,customer {id}countryCode,deliveryAddressPreferences {... on MailingAddress {address1,address2,city,provinceCode,countryCodeV2,zip}}}}}}",
        variables: {
            "cartId": cartId,
            "lines": cartLines
        }
    });
    const requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: graphql,
        redirect: 'follow'
    };

    fetch(config.shopifyApi, requestOptions)
        .then(response => response.json())
        .then(result => successCallback(result))
        .catch(error => failCallback(error));
}

window.cartLineRemove = (storefrontToken, cartId, lineIds, successCallback, failCallback) => {
    const myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");
    myHeaders.append("X-Shopify-Storefront-Access-Token", storefrontToken);

    const graphql = JSON.stringify({
        query: "mutation cartLinesRemove($cartId: ID!, $lineIds: [ID!]!) {cartLinesRemove(cartId: $cartId, lineIds: $lineIds) {cart {id,note,checkoutUrl,discountCodes{applicable, code},totalQuantity,createdAt,updatedAt,lines(first: 100) {edges {node {id,quantity,merchandise {... on ProductVariant {id,title,quantityAvailable,image{url},product{title}}},cost {amountPerQuantity{amount,currencyCode},compareAtAmountPerQuantity{amount,currencyCode},subtotalAmount{amount,currencyCode},totalAmount{amount,currencyCode}},attributes{key,value}}}},attributes{key,value},cost {totalAmount {amount,currencyCode} subtotalAmount {amount,currencyCode} totalTaxAmount {amount,currencyCode} totalDutyAmount {amount,currencyCode}}buyerIdentity {email,phone,customer {id} countryCode,deliveryAddressPreferences {... on MailingAddress {address1,address2,city,provinceCode,countryCodeV2,zip}}}}userErrors {field,message}}}",
        variables: {
            "cartId": cartId,
            "lineIds": lineIds
        }
    });
    const requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: graphql,
        redirect: 'follow'
    };

    fetch(config.shopifyApi, requestOptions)
        .then(response => response.json())
        .then(result => successCallback(result))
        .catch(error => failCallback(error));
}

window.cartNoteUpdate = (storefrontToken, cartId, note, successCallback, failCallback) => {
    const myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");
    myHeaders.append("X-Shopify-Storefront-Access-Token", storefrontToken);

    const graphql = JSON.stringify({
        query: "mutation cartNoteUpdate($cartId: ID!, $note: String) {cartNoteUpdate(cartId: $cartId, note: $note) {cart {id,createdAt,updatedAt,note,checkoutUrl,discountCodes{applicable, code},totalQuantity,lines(first: 100) {edges {node {id,quantity,merchandise {... on ProductVariant {id,title,quantityAvailable,image{url},product{title}}},cost {amountPerQuantity{amount,currencyCode},compareAtAmountPerQuantity{amount,currencyCode},subtotalAmount{amount,currencyCode},totalAmount{amount,currencyCode}},attributes{key,value}}}},attributes{key,value},cost {totalAmount {amount,currencyCode} subtotalAmount {amount,currencyCode} totalTaxAmount {amount,currencyCode} totalDutyAmount {amount,currencyCode}} buyerIdentity {email,phone,customer {id} countryCode,deliveryAddressPreferences {... on MailingAddress {address1,address2,city,provinceCode,countryCodeV2,zip}}}}userErrors {field,message}}}",
        variables: {
            "cartId": cartId,
            "note": note
        }
    });
    const requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: graphql,
        redirect: 'follow'
    };

    fetch(config.shopifyApi, requestOptions)
        .then(response => response.json())
        .then(result => successCallback(result))
        .catch(error => failCallback(error));
}

window.cartDiscountCodesUpdate = (storefrontToken, cartId, discountCodes, successCallback, failCallback) => {
    const myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");
    myHeaders.append("X-Shopify-Storefront-Access-Token", storefrontToken);

    const graphql = JSON.stringify({
        query: "mutation cartDiscountCodesUpdate($cartId: ID!, $discountCodes: [String!]) {cartDiscountCodesUpdate(cartId: $cartId, discountCodes: $discountCodes) {cart {id,createdAt,updatedAt,note,checkoutUrl,discountCodes{applicable, code},totalQuantity,lines(first: 100) {edges {node {id,quantity,merchandise {... on ProductVariant {id,title,quantityAvailable,image{url},product{title}}},cost {amountPerQuantity{amount,currencyCode},compareAtAmountPerQuantity{amount,currencyCode},subtotalAmount{amount,currencyCode},totalAmount{amount,currencyCode}},attributes{key,value}}}},attributes{key,value},cost {totalAmount {amount,currencyCode} subtotalAmount {amount,currencyCode} totalTaxAmount {amount,currencyCode} totalDutyAmount {amount,currencyCode}} buyerIdentity {email,phone,customer {id} countryCode,deliveryAddressPreferences {... on MailingAddress {address1,address2,city,provinceCode,countryCodeV2,zip}}}}userErrors {field,message}}}",
        variables: {
            "cartId": cartId,
            "discountCodes": discountCodes
        }
    });
    const requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: graphql,
        redirect: 'follow'
    };

    fetch(config.shopifyApi, requestOptions)
        .then(response => response.json())
        .then(result => successCallback(result))
        .catch(error => failCallback(error));
}

window.createAccessToken = (storefrontToken, email, pwd, successCallback, failCallback) => {
    const myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");
    myHeaders.append("X-Shopify-Storefront-Access-Token", storefrontToken);

    const graphql = JSON.stringify({
        query: "mutation customerAccessTokenCreate($input: CustomerAccessTokenCreateInput!) {customerAccessTokenCreate(input: $input) {customerAccessToken {accessToken},customerUserErrors {message}}}",
        variables: {"input": {"email": email, "password": pwd}}
    });
    const requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: graphql,
        redirect: 'follow'
    };

    fetch(config.shopifyApi, requestOptions)
        .then(response => response.json())
        .then(result => successCallback(result))
        .catch(error => failCallback(error));
}

window.updateCartBuyerIdentity = (storefrontToken, cartId, buyerIdentity, successCallback, failCallback) => {
    var myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");
    myHeaders.append("X-Shopify-Storefront-Access-Token", storefrontToken);

    var graphql = JSON.stringify({
        query: "mutation cartBuyerIdentityUpdate($buyerIdentity: CartBuyerIdentityInput!, $cartId: ID!) {cartBuyerIdentityUpdate(buyerIdentity: $buyerIdentity, cartId: $cartId) {cart {id, createdAt, updatedAt, note, checkoutUrl, totalQuantity, lines(first: 100) {edges {node {id, quantity, merchandise {... on ProductVariant {id,title,quantityAvailable,image{url},product{title,onlineStoreUrl}}},cost {amountPerQuantity{amount,currencyCode},compareAtAmountPerQuantity{amount,currencyCode},subtotalAmount{amount,currencyCode },totalAmount{amount,currencyCode}},attributes{key,value}}}},attributes{key,value},cost {totalAmount {amount,currencyCode},subtotalAmount {amount,currencyCode},totalTaxAmount {amount,currencyCode},totalDutyAmount {amount,currencyCode}},buyerIdentity {email,phone,customer {id},countryCode,deliveryAddressPreferences {... on MailingAddress {address1,address2,city,provinceCode,countryCodeV2,zip}}}},userErrors {field,message}}}",
        variables: {"buyerIdentity": buyerIdentity, "cartId": cartId}
    })
    var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: graphql,
        redirect: 'follow'
    };

    fetch(config.shopifyApi, requestOptions)
        .then(response => response.json())
        .then(result => successCallback(result))
        .catch(error => failCallback(error));
}